import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, useDashboardDispatch, useDashboardState } from './dashboard-context';
import DashboardAppService from '../../../../application/platform/apm/dashboard/dashboard-app-service';
import { useActionRunner } from '../../../../hooks/use-action-runner';

export const useDashboardController = () => {
    const navigate = useNavigate();
    const dispatch = useDashboardDispatch();
    const state = useDashboardState();
    const { run } = useActionRunner();

    async function loadData(upcomingDays: number = state.upcomingDays) {
        dispatch({ type: ACTION_TYPES.setLoading, payload: true });
        await run('Não foi possível carregar o dashboard', async () => {
            dispatch({ type: ACTION_TYPES.setData, payload: await DashboardAppService.get(upcomingDays) });
        });
        dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }

    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleUpcomingDaysChange(upcomingDays: number) {
        dispatch({ type: ACTION_TYPES.setUpcomingDays, payload: upcomingDays });
        loadData(upcomingDays);
    }

    return { loadData: () => loadData(), handleUpcomingDaysChange, navigate };
};
